module.exports = __webpack_public_path__ + "img/gebrateneudonseitlich.c5b0b6f5.jpg";